var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-dashboard"},[_c('Projects',{on:{"on-project-select":function (data) { return (_vm.selectedProject = data); }}}),_c('TeamMembers',{staticClass:"md-margin-top",attrs:{"project":_vm.selectedProject}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }